import type React from 'react';
import { SegmentedToggle } from './segmented-toggle';

type DisplayQuantityToggleProperties = {
  displayInCases: boolean;
  setDisplayInCases: (displayInCases: boolean) => void;
};

export const DisplayQuantityToggle: React.FC<DisplayQuantityToggleProperties> = ({
  displayInCases,
  setDisplayInCases,
}) => {
  return (
    <SegmentedToggle
      value={displayInCases ? 'cases' : 'units'}
      onChange={(value) => setDisplayInCases(value === 'cases')}
      options={[
        { value: 'units', label: 'Units' },
        { value: 'cases', label: 'Cases' },
      ]}
    />
  );
};
